import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    TextField, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, InputAdornment, Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const CUSTOM_REPORTS = [
    {
        route: "reports-etk-orders",
        title: "ETK Orders",
        category: "Lab Orders",
        description: "View ETK (Environmental Test Kit) orders within a date range. Supports PDF export.",
    },
    {
        route: "reports-bottle-count",
        title: "Bottle Count - Date Range (Due Date)",
        category: "Bottle Orders",
        description: "Filter by Kit Build Due Date and Bottle Order Status. Groups ordered bottles by name with counts — useful for planning how many of each bottle type to build.",
    },
];

const CustomReports = () => {
    const navigate = useNavigate();
    const [search, setSearch] = useState("");

    const filtered = CUSTOM_REPORTS.filter((r) => {
        const q = search.toLowerCase();
        return (
            r.title.toLowerCase().includes(q) ||
            r.category.toLowerCase().includes(q) ||
            r.description.toLowerCase().includes(q)
        );
    });

    return (
        <div className="vlp-component-container">
            <span className="title">Custom Reports</span>
            <hr />

            <TextField
                placeholder="Search reports..."
                size="small"
                variant="outlined"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                sx={{ mb: 2, width: 320 }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon fontSize="small" />
                        </InputAdornment>
                    ),
                }}
            />

            <Paper variant="outlined">
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow sx={{ backgroundColor: "primary.main" }}>
                                <TableCell sx={{ color: "white", fontWeight: 700, width: "25%" }}>Report Name</TableCell>
                                <TableCell sx={{ color: "white", fontWeight: 700, width: "15%" }}>Category</TableCell>
                                <TableCell sx={{ color: "white", fontWeight: 700 }}>Description</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filtered.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={3}>
                                        <Typography variant="body2" color="text.secondary" sx={{ py: 1 }}>
                                            No reports match your search.
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            ) : (
                                filtered.map((report, idx) => (
                                    <TableRow
                                        key={report.route}
                                        hover
                                        onClick={() => navigate(`/${report.route}`)}
                                        sx={{
                                            cursor: "pointer",
                                            backgroundColor: idx % 2 === 0 ? "rgba(0,0,0,0.03)" : "white",
                                        }}
                                    >
                                        <TableCell>
                                            <span style={{ display: "flex", alignItems: "center", gap: 6, color: "#1976d2", fontWeight: 500 }}>
                                                <OpenInNewIcon sx={{ fontSize: 15 }} />
                                                {report.title}
                                            </span>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2">{report.category}</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2" color="text.secondary">{report.description}</Typography>
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </div>
    );
};

export default CustomReports;
